import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { GoogleAuthProvider, OAuthProvider } from 'firebase/auth';

// Debug environment variables
console.log('Environment check:', {
  apiKeyExists: !!process.env.REACT_APP_FIREBASE_API_KEY,
  projectIdExists: !!process.env.REACT_APP_FIREBASE_PROJECT_ID,
  authDomainExists: !!process.env.REACT_APP_FIREBASE_AUTH_DOMAIN
});

// Validate required config
if (!process.env.REACT_APP_FIREBASE_API_KEY) {
  throw new Error('Firebase API key is missing. Check your .env file.');
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'flashcards-web-3ba3c.firebaseapp.com',
  projectId: 'flashcards-web-3ba3c',  // Hardcode the project ID
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'flashcards-web-3ba3c.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore with default database
const db = getFirestore(app);

// Remove any existing persistence or emulator connections
if (process.env.NODE_ENV === 'development') {
  // connectFirestoreEmulator(db, 'localhost', 8080);
}

// Initialize other services
const auth = getAuth(app);
const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();

googleProvider.addScope('https://www.googleapis.com/auth/userinfo.email');
googleProvider.addScope('https://www.googleapis.com/auth/userinfo.profile');
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Add debug logging before setup
console.log('Setting up Apple Sign In with:', {
  redirectUri: 'https://flashcards-web-3ba3c.firebaseapp.com/__/auth/handler',
  clientId: 'greencards-earth',
  teamId: process.env.REACT_APP_APPLE_TEAM_ID,
  keyId: process.env.REACT_APP_APPLE_KEY_ID
});

const appleProvider = new OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');

appleProvider.setCustomParameters({
  redirect_uri: 'https://flashcards-web-3ba3c.firebaseapp.com/__/auth/handler',
  client_id: 'greencards-earth',
  response_type: 'code id_token',  // Changed back to include id_token
  response_mode: 'fragment',
  scope: 'email name'  // Add explicit scope
});

// Add error handling debug
console.log('Apple provider configured:', {
  providerId: appleProvider.providerId,
  scopes: appleProvider.scopes,
  parameters: appleProvider.customParameters,
  state: appleProvider.customParameters.state
});

// Debug logging
console.log('Firebase initialized:', {
  projectId: firebaseConfig.projectId,
  databaseInstance: db._databaseId
});

export { db, auth, app, storage, googleProvider, appleProvider }; 